<template>
  <div class="sfboxl2">
    <div class="wfull">
        <div class="hotfbox">
            <div id="contentbox" class="after-sales-wfull-left1">
                <div class="details-head">
                    <div class="details-title">
                        <p>公司介绍</p>
                    </div>

                    <div class="terartboto">您所在的位置：关于我们 > <a href="javascript:void" rel="category tag">关于企业</a> > 公司介绍</div>
                </div>
                <div class="datails-content">
                    <div>
                        <p style="text-indent:2em">
奇克（上海）实业有限公司创立于2014年，由专业的销售团队，提供进口化工原料及塑料加工助剂的销售和支持。致力于高性能的塑料改性和特种塑料改性行业。
本公司先后取得韩国KC公司中国大陆地区电缆料市场代理权和韩国全景化学公司在中国大陆地区代理权等。销售的氢氧化铝、氢氧化镁阻燃剂、粉末丁腈橡胶、硅酮塑料加工助剂等产品在市场领域得到了很好的应用，广泛受到了客户的好评。在新老客户的大力支持下，我们赋予最稳定的产品和优质的服务于客户，相信我们将以最诚挚的服务，优惠的价格，与您共创双赢！

                        </p>
                    </div>
                </div>
                <div class="datails-foot">

                </div>
            </div>

        </div>
    </div>

    <div class="clear">
    </div>
</div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 p{
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// About.vue?239bc4d7